import { render, staticRenderFns } from "./OperQoshimcha.vue?vue&type=template&id=3ca6b817&scoped=true"
import script from "./OperQoshimcha.vue?vue&type=script&lang=js"
export * from "./OperQoshimcha.vue?vue&type=script&lang=js"
import style0 from "./OperQoshimcha.vue?vue&type=style&index=0&id=3ca6b817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6b817",
  null
  
)

export default component.exports